import React from 'react';
import { Button, Col, Form, FormGroup, Input } from 'reactstrap';
import { useForm, ValidationError } from '@formspree/react';


const ContactForm1 = () => {
    const [state, handleSubmit] = useForm("mjvneoeb");
    if (state.succeeded) {
        return <div style={{display: "flex", justifyContent: "center", alignItems: "center" }}><p style={{color: "#1ec8ff", fontWeight: "bold"}}>Mulțumim! Vom reveni către dumneavoastră în curând.</p></div>;
    }

    return (
        <div className="row justify-content-center text-center">
            <div className="col-12 col-lg-10">
                <Form id="contact-form" className="row" method="post" onSubmit={handleSubmit}>
                    <div className="messages" />
                    <FormGroup className="col-md-12">
                        <Input
                            id="name"
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Nume*"
                            required
                            data-error="Numele este obligatoriu"
                        />
                        <ValidationError
                            prefix="Nume"
                            field="name"
                            errors={state.errors}
                        />
                        {/*<div className="help-block with-errors" />*/}
                    </FormGroup>
                    {/*<FormGroup className="col-md-6">*/}
                    {/*    <Input*/}
                    {/*        id="form_name1"*/}
                    {/*        type="text"*/}
                    {/*        name="name"*/}
                    {/*        className="form-control"*/}
                    {/*        placeholder="Last Name"*/}
                    {/*        required*/}
                    {/*        data-error="Name is required."*/}
                    {/*    />*/}
                    {/*    <div className="help-block with-errors" />*/}
                    {/*</FormGroup>*/}
                    <FormGroup className="col-md-12">
                        <Input
                            id="email"
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email*"
                            required
                            data-error="Adresa de email este obligatorie"
                        />
                        <ValidationError
                            prefix="Email"
                            field="email"
                            errors={state.errors}
                        />
                        {/*<div className="help-block with-errors" />*/}
                    </FormGroup>
                    <FormGroup className="col-md-12">
                        <Input
                            id="phone"
                            type="tel"
                            name="phone"
                            className="form-control"
                            placeholder="Telefon"
                            // required
                            // data-error="Telefonul este obligatoriu"
                        />
                        {/*<div className="help-block with-errors" />*/}
                    </FormGroup>
                    {/*<FormGroup className="col-md-6">*/}
                    {/*    <Input type="select" className="form-control">*/}
                    {/*        <option>- Select Service</option>*/}
                    {/*        <option>Consulting</option>*/}
                    {/*        <option>Finance</option>*/}
                    {/*        <option>Marketing</option>*/}
                    {/*        <option>Avanced Analytics</option>*/}
                    {/*        <option>planning</option>*/}
                    {/*    </Input>*/}
                    {/*</FormGroup>*/}
                    {/*<FormGroup className="col-md-6">*/}
                    {/*    <Input*/}
                    {/*        id="form_subject"*/}
                    {/*        type="tel"*/}
                    {/*        name="subject"*/}
                    {/*        className="form-control"*/}
                    {/*        placeholder="Subject"*/}
                    {/*        required*/}
                    {/*        data-error="Subject is required"*/}
                    {/*    />*/}
                    {/*    <div className="help-block with-errors" />*/}
                    {/*</FormGroup>*/}
                    <FormGroup className="col-md-12">
                        <Input
                            id="message"
                            type="textarea"
                            name="message"
                            className="form-control"
                            placeholder="Mesaj*"
                            rows={4}
                            required
                            data-error="Vă rugăm să adaugați un mesaj"
                        />
                        <ValidationError
                            prefix="Mesaj"
                            field="message"
                            errors={state.errors}
                        />
                        {/*<div className="help-block with-errors" />*/}
                    </FormGroup>
                    <Col md="12" className="text-center mt-4">
                        <Button type="submit" disabled={state.submitting} color="primary">
                            <span>Trimite mesaj</span>
                        </Button>
                    </Col>
                </Form>
            </div>
        </div>
    );
};

export default ContactForm1;
